import { equalIgnoreCase }            from '../../utils';
import { PageSEOInterface, PagesSEO } from '../constants/PagesSEO';
import { Categories, Pages }          from '../constants/Pages';

export class PageService {

    public static findPageSlug(alias: string): Pages | Categories {
        const found = PagesSEO.find(pageSEO => equalIgnoreCase(alias, pageSEO.URLAlias));

        return found ? found.Arena5Slug : null;
    }

    public static getPageSEO(page: Pages | Categories): PageSEOInterface {
        return PagesSEO.find(pageSEO => pageSEO.Arena5Slug === page);
    }
}
